import { useBlockProps, InspectorControls } from '@wordpress/block-editor';
import { PanelBody, TextControl } from '@wordpress/components';
import { useSelect } from '@wordpress/data';
import { store as coreStore } from '@wordpress/core-data';
import { __ } from '@wordpress/i18n';

export default function Edit( { attributes, setAttributes } ) {
	const { copyrightText } = attributes;
	const blockProps = useBlockProps( { className: 'coziehomes-footer-credit' } );
	const year = new Date().getFullYear();

	const siteName = useSelect( ( select ) => {
		const site = select( coreStore ).getSite();
		return site?.title || __( 'Site Name', 'coziehomes' );
	}, [] );

	return (
		<>
			<InspectorControls>
				<PanelBody title={ __( 'Settings', 'coziehomes' ) }>
					<TextControl
						label={ __( 'Copyright Text', 'coziehomes' ) }
						value={ copyrightText }
						onChange={ ( value ) => setAttributes( { copyrightText: value } ) }
						placeholder={ __( 'e.g. All rights reserved.', 'coziehomes' ) }
					/>
				</PanelBody>
			</InspectorControls>
			<div { ...blockProps }>
				<div className="coziehomes-footer-credit__inner">
					<p className="coziehomes-footer-credit__copyright">
						&copy; { year }{ ' ' }
						<span className="coziehomes-footer-credit__link">
							{ siteName }
						</span>
						{ copyrightText && (
							<>
								<span className="coziehomes-footer-credit__separator">|</span>
								<span className="coziehomes-footer-credit__text">
									{ copyrightText }
								</span>
							</>
						) }
					</p>
				</div>
			</div>
		</>
	);
}
